import { html, css, LitElement } from '../../../../../jb-nexus/node_modules/lit';
import * as Toast from '../../../../../jb-nexus/node_modules/bootstrap/js/dist/toast';
import { NexusComponent } from './nexus.component';
import { StorageModule } from './storage.module';

export class ThemePickerComponent extends NexusComponent {

    static properties = {
        title: {
            type: String,
            attribute: true,
        },
        themeId: {
            type: String,
            attribute: true,
            reactive: true,
        },
        theme: {
            attribute: 'theme',
            reflect: true,
        },
    }

    currentLink = null;
    cachedLink = null;

    createRenderRoot() {
        return this;
    }


    static get styles() {
        // Write styles in standard CSS
        // https://stackoverflow.com/questions/25193964/how-can-i-have-a-web-components-width-and-height-be-inherited-by-its-children
        return css`
			:host {
			display: flex;  /* or display: block; */
            position: relative;
            margin: 0;
			}
		`;
    }
    constructor() {
        super();
        this.title = null;
        this.themeId;
        this.storageModule = new StorageModule();
        this.preloadStyleSheets();
    }

    /**
     * 
     */
    preloadStyleSheets() {
        // now make a new link href after the child-style-css, with some identifier;
        let href = this.buildLinkByTheme('dark');
        console.log('href...', href);
        let newLink = document.createElement('link');
        newLink.setAttribute('rel', 'preload');
        newLink.as = 'style';
        newLink.setAttribute('id', 'preloaded-child-style-css');
        newLink.setAttribute('href', href);
        

        let oldLink = document.head.querySelector('#child-style-css');
        console.log('oldLink', oldLink);
        if (oldLink) {
            oldLink.insertAdjacentElement('afterend', newLink);
        }
    }

    prepareTheme() {
        // this.themeId = themeId;
        switch (this.themeId) {
            case 'dark':
                this.buildLink();
                this.setBodyTheme('dark');
                this.switchTheme();
                this.handleDarkMode();
                break;
            case 'light':
                // light mode, set attribute
                this.buildLink();
                this.setBodyTheme('light');
                this.switchTheme();
                this.handleLightMode();
                break;
        }

    }

    setBodyTheme(theme) {
        if (this.getBody()) {
            console.log('got body...');
            this.getBody().setAttribute('data-bs-theme', theme);
        }
    }

    buildLink() {
        if (typeof document !== 'undefined') {
            var link = document.querySelector('head link[id="child-style-css');
            if (this.cachedLink == null && link) {
                this.cachedLink = link.getAttribute('href');
            }
            if (link) {
                var search = 'index2';
                var i = this.cachedLink.indexOf(search);
                var j = this.cachedLink.substr(0, i);
                var c = `${j}${search}${this.buildThemeStringPart()}.css`;
                this.currentLink = c;
                return;
                // link.setAttribute('href', c);
            }
        }
        return null;
    }

    buildLinkByTheme(theme) {
        if (typeof document !== 'undefined') {
            var link = document.querySelector('head link[id="child-style-css');
            if (this.cachedLink == null && link) {
                this.cachedLink = link.getAttribute('href');
            }
            if (link) {
                var search = 'index2';
                var i = this.cachedLink.indexOf(search);
                var j = this.cachedLink.substr(0, i);
                var c = `${j}${search}${this.buildThemeStringPartByThemeId(theme)}.css`;
                return c;
                // link.setAttribute('href', c);
            }
        }
        return null;
    }

    /**
     * 
     */
    switchTheme() {
        // now make a new link href after the child-style-css, with some identifier;
        let newLink = document.createElement('link');
        newLink.setAttribute('rel', 'stylesheet');
        newLink.setAttribute('id', 'new-child-style-css');
        // add the new file value to its href;
        newLink.setAttribute('href', this.currentLink);
        // remove the previous link child-style-css
        // add child-style-css id to new css link

        let oldLink = document.head.querySelector('#child-style-css');
        console.log('oldLink', oldLink);
        if (oldLink) {
            oldLink.insertAdjacentElement('afterend', newLink);
            document.head.removeChild(oldLink);
            newLink.setAttribute('id', 'child-style-css');
        }

    }

    handleDarkMode() {
        if (typeof document !== 'undefined' && document.documentElement) {
            let body = document.documentElement.querySelector('body');
            if (body) {
                body.setAttribute('data-bs-theme', 'dark');
                let themableElements = document.querySelectorAll('[theme]');
                themableElements.forEach(themableElement => {
                    themableElement.setAttribute('theme', 'dark');
                });
            }
        }
    }

    handleLightMode() {
        if (typeof document !== 'undefined' && document.documentElement) {
            let body = document.querySelector('body');
            if (body) {
                body.setAttribute('data-bs-theme', 'light');
                let themableElements = document.querySelectorAll('[theme]');
                themableElements.forEach(themableElement => {
                    themableElement.setAttribute('theme', 'light');
                });
            }
        }
    }

    // TODO: Important! Use 'updated' instead of 'update' because 'update' is used to update, and 'updated' is used to handle updated DOM
    updated() {
        // const toasts = this.renderRoot.querySelectorAll('.toast');
        // [...toasts].map(toast => new Toast(toast, {
        //     animation: true,
        //     autohide: false,
        // }));
        // const toast = this.renderRoot.getElementById('liveToast');

        // if (toast) {
        //     const toastBootstrap = Toast.getOrCreateInstance(toast);
        //     toastBootstrap.show();
        //     toast.querySelector('[data-bs-dismiss]').addEventListener('click', () => {
        //         toastBootstrap.hide();
        //     });
        // }
    }

    firstUpdated() {
        console.log('firstUpdated');
        window.addEventListener('load', () => {
            this.handleInitialTheme();
        });
    }

    handleInitialTheme() {
        if (this.getBody()) {
            let prefersDarkColorScheme = parseInt(getComputedStyle(document.documentElement).getPropertyValue(`--nexus-prefers-dark-color-scheme`));

            console.log('prefersDarkColorScheme', prefersDarkColorScheme);
            let themeLocalStorage = this.storageModule.getItem('localStorage', 'color-theme');
            if (prefersDarkColorScheme === 1 && themeLocalStorage === null) {
                this.themeId = 'dark';
                this.storageModule.setItem('localStorage', 'color-theme', this.themeId);
                this.prepareTheme();
                return;
            } else {
                themeLocalStorage = this.storageModule.getItem('localStorage', 'color-theme');
                console.log('themeLocalStorage', themeLocalStorage);
                if (themeLocalStorage) {
                    this.themeId = themeLocalStorage;
                    this.prepareTheme();
                }
                let themeBodyAttribute = this.getBody().getAttribute('data-bs-theme');
                if (themeBodyAttribute) {
                    console.log('themeBodyAttribute', themeBodyAttribute);
                    this.themeId = themeBodyAttribute;
                    this.storageModule.setItem('localStorage', 'color-theme', this.themeId);
                    this.prepareTheme();
                }
            }
        }
        return;
    }

    buildThemeStringPart() {
        var result = '';
        if (this.themeId) {
            result = `-${this.themeId}`;
        }
        if (this.themeId == 'light') {
            result = ``;
        }
        return result;
    }

    buildThemeStringPartByThemeId(themeId) {
        var result = '';
        if (themeId) {
            result = `-${themeId}`;
        }
        if (themeId == 'light') {
            result = ``;
        }
        return result;
    }


    handleDarkThemeSwitchClick() {
        console.log('handleDarkThemeSwitchClick start', this.themeId, this);
        switch (this.themeId) {
            case 'light':
                this.themeId = 'dark';
                break;
            case 'dark':
                this.themeId = 'light';
            default:
                break;
        }
        this.prepareTheme();
        this.switchTheme();
        this.storageModule.setItem('localStorage', 'color-theme', this.themeId);
        console.log('handleDarkThemeSwitchClick end', this.themeId);
    }

    doRender() {
        let result = html``;
        result = html`
            <button @click="${this.handleDarkThemeSwitchClick}" type="button" class="nav-icon-button" aria-label="Switch between light mode and dark mode">
                <svg lang="en-GB" class="icon-dark-mode svg-icon svg-icon-hover svg-icon-size-15 align-self-end my-auto">
                <title>Dark</title>
                    <use xlink:href="#icon-dark-mode"></use>
                </svg>
                <svg lang="en-GB" class="icon-light-mode svg-icon svg-icon-hover svg-icon-size-15 align-self-end my-auto">
                    <title>Light</title>
                    <use xlink:href="#icon-light-mode"></use>
                </svg>
            </button>
                `;
        return result;
    }

    getBody() {
        let body = document.querySelector('body');
        return body;
    }

    render() {
        return html`${this.doRender()}`;
    }
}
window.customElements.define('theme-picker', ThemePickerComponent);

